import { render, staticRenderFns } from "./socios-administradores.vue?vue&type=template&id=7dce1851&"
import script from "./socios-administradores.vue?vue&type=script&lang=js&"
export * from "./socios-administradores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports